import React from 'react';
import {connect} from 'react-redux';

import {createPhoneConfirmation as createPhoneConfirmationAction,
    confirmPhone as confirmPhoneAction,
    denyConfirmation as denyConfirmationAction} from 'actions/creators/PhoneConfirmation';

import PhoneInput from 'shared/components/PhoneConfirmation/PhoneInput.jsx';
import CodeInput from 'shared/components/PhoneConfirmation/CodeInput.jsx';
import ConfirmSuccess from 'shared/components/PhoneConfirmation/ConfirmSuccess.jsx';

class PhoneConfirmation extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        gamblerId: React.PropTypes.number.isRequired,
        joinPromoType: React.PropTypes.any,
        phone: React.PropTypes.string,
        phoneConfirming: React.PropTypes.bool.isRequired,
        phoneConfirmationRequested: React.PropTypes.bool.isRequired,
        phoneConfirmed: React.PropTypes.bool.isRequired,
        phoneConfirmationError: React.PropTypes.any,
        createPhoneConfirmationAction: React.PropTypes.func.isRequired,
        confirmPhoneAction: React.PropTypes.func.isRequired,
        denyConfirmationAction: React.PropTypes.func.isRequired,
        cancelCallback: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._handleDenialClick = this._handleDenialClick.bind(this);
    }

    _handleDenialClick(e) {
        e.preventDefault();

        this.props.denyConfirmationAction();
    }

    render() {
        const {languageId, gamblerId, joinPromoType, phone, phoneConfirming,
            phoneConfirmationRequested, phoneConfirmationError, phoneConfirmed,
            cancelCallback} = this.props;

        const defaultValues = {
            initialValues: {
                phone
            }
        };

        const phoneInputProps = {
            languageId,
            gamblerId,
            joinPromoType,
            phone,
            phoneConfirming,
            phoneConfirmationError,
            createPhoneConfirmation: this.props.createPhoneConfirmationAction,
            denyConfirmationCallback: this._handleDenialClick,
            ...defaultValues
        };

        const codeInputProps = {
            languageId,
            gamblerId,
            phone,
            phoneConfirming,
            phoneConfirmationError,
            confirmPhone: this.props.confirmPhoneAction,
            denyConfirmationCallback: this._handleDenialClick
        };

        const confirmSuccessProps = {
            languageId,
            joinPromoType,
            phone,
            cancelCallback
        };

        return (
            <div>
                {!phoneConfirmationRequested && <PhoneInput {...phoneInputProps}/>}
                {phoneConfirmationRequested && !phoneConfirmed && <CodeInput {...codeInputProps}/>}
                {phoneConfirmed && <ConfirmSuccess {...confirmSuccessProps}/>}
            </div>
        );
    }
}

function select() {
    return {};
}

export default connect(select, {
    createPhoneConfirmationAction,
    confirmPhoneAction,
    denyConfirmationAction
})(PhoneConfirmation);



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/regular/PhoneConfirmation.jsx